const initialState = {
  segments: null,
}

export default initialState;
